// features/workstations/dashboard-sections/thesis.js
// ═══════════════════════════════════════════════════════════
// Today's Thesis (Day Trading)
// Top of the morning page — what's the trade today?
// ═══════════════════════════════════════════════════════════
//
// V1 (this commit): displays the workstation identity + a
// thesis composed from config (window, instruments, setup
// types). Shift's Read footer is a static synthesis line.
//
// V2 (Phase 3b): pulls today's actual market posture +
// generates the thesis line dynamically from yesterday's
// session log + current FOMC/regime state.
// ═══════════════════════════════════════════════════════════

import ShiftRead from './shift-read';

export default function ThesisSection({ workstation }) {
  const config = workstation?.config || {};
  const identity = config.identity || {};
  const criteria = config.criteria || {};

  const tradingWindow =
    identity.trading_window_start && identity.trading_window_end
      ? `${identity.trading_window_start} – ${identity.trading_window_end} ET`
      : null;

  const instruments = identity.primary_instruments || [];
  const setups = criteria.setup_types || criteria.setups || [];

  return (
    <section className="ws-section ws-section-thesis">
      <div className="ws-section-header">
        <div className="ws-section-label">Today&rsquo;s Thesis</div>
        <div className="ws-section-time">{todayLabel()}</div>
      </div>
      <div className="ws-section-body">
        <div className="ws-thesis-headline">
          Trade <em>only</em> what aligns. The window is short.
          The setups are known.
        </div>

        <div className="ws-thesis-meta">
          {tradingWindow && (
            <div className="ws-thesis-meta-row">
              <span className="ws-thesis-meta-key">Window</span>
              <span className="ws-thesis-meta-val">{tradingWindow}</span>
            </div>
          )}
          {instruments.length > 0 && (
            <div className="ws-thesis-meta-row">
              <span className="ws-thesis-meta-key">Instruments</span>
              <span className="ws-thesis-meta-val">{instruments.join(' · ')}</span>
            </div>
          )}
          {identity.dte_only && (
            <div className="ws-thesis-meta-row">
              <span className="ws-thesis-meta-key">DTE</span>
              <span className="ws-thesis-meta-val">{identity.dte_only}</span>
            </div>
          )}
          {setups.length > 0 && (
            <div className="ws-thesis-meta-row">
              <span className="ws-thesis-meta-key">Setups</span>
              <span className="ws-thesis-meta-val">
                {setups.map((s) => s.label || s.name || s).join(' · ')}
              </span>
            </div>
          )}
        </div>

        <ShiftRead>
          {tradingWindow
            ? `${tradingWindow} is your only edge today. Outside the window, you are guessing.`
            : 'Define your window. Trade inside it. Walk away when it closes.'}
        </ShiftRead>
      </div>
    </section>
  );
}

function todayLabel() {
  try {
    return new Date().toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '';
  }
}
